
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/password",
      function () {
        return require("private-next-pages/login/password.tsx");
      }
    ]);
  